// extracted by mini-css-extract-plugin
export default {"settings-button":"SettingsPanels_settings-button__fBREB","drawer":"SettingsPanels_drawer__Aghwz"};